<template>
  <div>
    <v-toolbar
      flat
      color="white"
      class="elevation-1"
      :height="$store.getters.toolbarHeight"
    >
      <v-toolbar-title>Bienvenido/a <span v-if="usuario"> {{usuario.persona.nombre}}</span></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container class="pa-25">
      <template v-if="rolSeleccionado">
        <component
          v-bind:is="rolSeleccionado.componente"
          v-bind="rolSeleccionado.props"
        >
        </component>
      </template>
      <v-spinner v-if="cargando"></v-spinner>
    </v-container>
  </div>
</template>

<script>
import DashboardPaciente from '../components/DashboardPaciente'
import DashboardSuperadmin from '../components/DashboardSuperadmin'
import DashboardSecretaria from '../components/DashboardSecretaria'
import DashboardMedico from '../components/DashboardMedico'
export default {
  computed: {
    configuracion () {
      return this.$store.getters.app
    },
    usuario () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      cargando: true,
      rolSeleccionado: null,
      vistasPorRol: {
        superadmin: {
          mostrar: true,
          titulo: 'Superadmin',
          componente: DashboardSuperadmin,
          props: {
            id: this.id,
            titulo: 'SuperAdmin'
          }
        },
        paciente: {
          mostrar: true,
          titulo: 'Paciente',
          componente: DashboardPaciente,
          props: {
            id: this.id
          }
        },
        secretaria: {
          mostrar: true,
          titulo: 'Secretaria',
          permiso: 'pacientes_agenda',
          componente: DashboardSecretaria,
          props: {
            id: this.id,
            titulo: 'Secretaria'
          }
        },
        medico: {
          mostrar: true,
          titulo: 'Medico',
          componente: DashboardMedico,
          props: {
            id: this.id,
            titulo: 'Sala de espera'
          }
        },
        tecnico: {
          mostrar: true,
          titulo: 'Medico',
          componente: DashboardMedico,
          props: {
            id: this.id,
            titulo: 'Sala de espera'
          }
        },
        directormedico: {
          mostrar: true,
          titulo: 'Medico',
          componente: DashboardMedico,
          props: {
            id: this.id,
            titulo: 'Sala de espera'
          }
        }
      }
    }
  },
  created () {
    this.$vuetify.theme.primary = process.env.VUE_APP_VUETIFY_THEME_PRIMARY
  },
  mounted () {
    this.mostrarVistaPorRol()
  },
  components: {
  },
  methods: {
    mostrarVistaPorRol () {
      if (this.usuario && this.usuario.roles.length > 0) {
        let rol = this.usuario.roles[0].name.toLowerCase().replace(' ', '')

        if (this.vistasPorRol[rol] !== 'undefined') {
          this.rolSeleccionado = this.vistasPorRol[rol]
          this.cargando = false
        }
      }
    }
  }
}
</script>
<style scoped>
/* .v-tabs__wrapper {
  background-color: #e41b23 !important;
}
.btn-login {
  background-color: #1a2574 !important;
  border-color: #1a2574 !important;
  border-radius: 15px;
  min-height: 48px;
  color: #fff;
}
.red {
  background-color: #e41b23 !important;
}
.blue {
  background-color: #1a2574 !important;
} */
@media only screen and (min-width: 1264px) {
  .container {
    max-width: 94%;
  }
}
</style>
